const note = {
	name: 'Notiz | Notizen',
	icon: '',
	fields: {
		priority: 'Priorität',
		subject: 'Betreff',
		notes_types: {
			name: 'Notizart',
		},
		date_start: 'Beginn',
		date_end: 'Ende',
		valid_until: 'Sichtbar bis',
	},
}

export default note
